import SEO from "../../components/SEO";
import { Link } from "react-router-dom";

const Cloud_services = () => {
    return (
        <div>
            <SEO
                title="Cloud Services | Blog | CloudVantage"
                description="Learn about cloud services and discover our latest updates and insights."
                keywords="cloud services, cloud computing, cloud solutions"
                author="CloudVantage"
                ogTitle="Cloud Services | Blog | CloudVantage"
                ogDescription="Learn about cloud services and discover our latest updates."
                ogImage="/assets/images/cloudvantage-blog-og.jpg"
                ogUrl={typeof window !== 'undefined' ? window.location.href : ''}
            />

            <div className="min-h-screen bg-blue-50 dark:bg-[#141D26] text-black dark:text-white py-12 px-4">
                <div className="max-w-4xl mx-auto text-center">
                    <h1 className="text-4xl md:text-5xl font-semibold mb-4 crimson-font">
                        Cloud Services
                    </h1>
                    <p className="text-lg text-gray-600 dark:text-gray-300 mb-8">
                        This page is coming soon. Check back later for cloud services content.
                    </p>
                    <Link
                        to="/blog"
                        className="bg-blue-500 hover:bg-blue-600 dark:bg-primaryBlue dark:hover:bg-primaryBlue/90 text-white font-semibold px-6 py-3 rounded-lg transition-colors inline-block"
                    >
                        Back to Blog
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Cloud_services;

